import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const Financing = () => {
  // Script is now loaded via Helmet in the return statement below
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <Helmet>
        <title>Financing Options | Savior Replacement Windows and Doors, LLC</title>
        <meta name="description" content="Flexible financing options for your window and door replacement project. Easy approval process with competitive rates." />
        <script src="https://www.enhancify.com/fullpagewidget/" async></script>
      </Helmet>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-navy-dark to-navy text-white py-24 mt-16">
        <div className="absolute inset-0 opacity-10">
          <img 
            src="https://images.unsplash.com/photo-1554224311-beee460201e8?w=1920&q=80"
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Flexible <span className="text-gold">Financing Options</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Make your window and door replacement project affordable with our easy financing solutions
          </p>
        </div>
      </section>

      {/* Enhancify Widget Section */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div 
            id='fullpagewidget' 
            data-color1='#BD921E' 
            data-color2='#3A3A37' 
            data-coBrandedColor='#FFFFFF' 
            data-page='9933704' 
            data-hideLink='0'
          />
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-navy-dark mb-4">
              Why Choose Our <span className="text-gold">Financing?</span>
            </h2>
            <p className="text-xl text-gray-600">
              Making quality windows and doors accessible to every homeowner
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-gold/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-navy-dark mb-2">Quick Approval</h3>
              <p className="text-gray-600">Fast and easy application process with instant decisions</p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-gold/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-navy-dark mb-2">Competitive Rates</h3>
              <p className="text-gray-600">Low interest rates and flexible payment terms</p>
            </div>

            <div className="text-center p-6">
              <div className="w-16 h-16 bg-gold/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-navy-dark mb-2">No Hidden Fees</h3>
              <p className="text-gray-600">Transparent pricing with no surprises</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Financing;
